import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaChevronRight } from "react-icons/fa";

import { Page, Ticket, LoadingScreen } from "ui/components";

import logo from "../../../assets/ic_launcher.png";
import { formatDate } from "utilities/common";
import { EmptyScreen } from "ui/components";
import { Shipment,  Manifest, Schedule } from "services/action";
import CounterManifest from "./component/counter.manifest";
import ScheduleAbsence from "./component/schedule.absence";

const HomeScreen = () => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateAuth = useSelector((state) => state?.Auth);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services["Manifest.Get"]
  );
  const [data, setData] = React.useState(null);
  const [total, setTotal] = React.useState(0);
  const [isEmpty, setEmpty] = React.useState(false);
  const [cod, setCOD] = React.useState(null);
  const [schedule, setSchedule] = React.useState(null);

  const $loadTotal = async () => {
    const req = await Dispatch(
      Manifest.$get({ status: "completed", limit: 1000000 })
    );

    if (req?.message === "success") {
      if (req?.total) {
        setTotal(req?.total);
      } else {
        setTotal(0);
      }
    }
  };

  const $loadCOD = async () => {
    const req = await Dispatch(Shipment.$cod());

    if (req?.message === "success") {
      setCOD(req?.data);
    }
  };

  const $loadProcess = async () => {
    const req = await Dispatch(Manifest.$get({ status: "process" }));

    if (req?.message === "success") {
      if (req?.data) {
        setData(req?.data);
        setEmpty(false);
      } else {
        setEmpty(true);
      }
    }
  };

  const $loadSchedule = async () => {
    const req = await Dispatch(Schedule.$showMe());

    if (req?.message === "success") {
      setSchedule(req?.data);
    }
  }

  React.useEffect(() => {
    $loadTotal();
    $loadProcess();
    $loadCOD();
    $loadSchedule()
  }, []);

  return (
    <Page hasFooter full>
      <div className="hero" style={{ height: schedule ? 265: 210}} />
      <div style={{ marginTop: schedule? -265: -210 }} className="px-3 py-2">
        <div className="d-flex flex-row mb-2 align-items-center">
          <div>
            <img
              src={logo}
              className="rounded-circle border border-2 border-white"
              alt=""
              style={{ height: 60, width: 60 }}
            />
          </div>
          <div className="px-2 text-white">
            <div>
              Hello, <b>{StateAuth?.session?.name}</b>
            </div>
            <small>Selamat datang kembali</small>
          </div>
        </div>

        <div
          className="bg-white rounded-3 px-2 py-3"
        >
          <CounterManifest cod={cod} total={total} />

          <ScheduleAbsence schedule={schedule} />

          <div className="d-flex align-items-center justify-content-between mt-3" onClick={() => History.push('/riwayat')}>
            <small>Lihat detail semua manifest</small>
            <FaChevronRight size={15} color="#2f83ba" />
          </div>
        </div>
      </div>

      {StateLoading ? (
        <LoadingScreen />
      ) : isEmpty ? (
        <EmptyScreen text="Anda belum memiliki pengiriman" />
      ) : (
        <div
          className="px-3 py-2"
          style={{
            maxHeight: "calc(100vh - 330px)",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <div className="text-uppercase fw-bold fs-6 py-1 mb-3 border-bottom">
            daftar manifest aktif
          </div>
          <div>
            {data?.map((d, i) => (
              <Ticket
                key={i}
                code={d?.code}
                date={formatDate(d?.schedule_at, "DD/MM/YYYY")}
                shipment={`Proses (${d?.legs_count?.completed || "-"}/${
                  d?.legs_count?.total || "-"
                })`}
                type={d?.type}
                onClick={() => History.push(`/manifest/${d?.id}`)}
              />
            ))}
          </div>
        </div>
      )}
    </Page>
  );
};

export default HomeScreen;
